export default function logout() {
	window.location.href = "/logout";
}
